import { Switch, Route, Router as WouterRouter } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import FounderProfile from "@/pages/FounderProfile";

// react-query is required even though no component in this file uses
// useQuery/useMutation directly: the auto-generated hooks in
// @workspace/api-client-react (Contact form's useSubmitContact) call
// useMutation under the hood and crash without a QueryClientProvider.
const queryClient = new QueryClient();

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      {/* Per-founder profile pages, e.g. /joe and /andy. FounderProfile
          renders <NotFound /> for any slug that isn't a known founder. */}
      <Route path="/:slug" component={FounderProfile} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <WouterRouter
          base={import.meta.env.BASE_URL.replace(/\/$/, "")}
          ssrPath="/"
        >
          <Router />
        </WouterRouter>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;